import type { MeUser } from "../api/types.js";
import { AgeKeyDisplay } from "./age-key-display.js";
import { HELP } from "./help-content.js";
import { SectionHeader } from "./help-button.js";

// 2.5.D.2: Profiili-kortti /asetukset-näkymää varten.
// Read-only v1 — vaihtoehtoinen muokkaus vasta vaiheessa 3+ (logout,
// email-vaihto, salasanan vaihto).

export function ProfileCard({ user }: { user: MeUser }) {
  return (
    <section className="rounded-lg border border-slate-700 bg-slate-900 p-6">
      <SectionHeader title="Profiili" help={HELP.profile!.body} />
      <dl className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
        <Row label="Nimi" value={user.name} />
        <Row label="Sähköposti" value={user.email} />
        <Row label="Roolit" value={user.roles.length > 0 ? user.roles.join(", ") : "—"} />
        <Row
          label="Rekisteröitynyt"
          value={formatDate(user.registeredAt)}
        />
        <Row
          label="Viimeisin kirjautuminen"
          value={formatDate(user.lastSignedInAt)}
        />
      </dl>
      <div className="mt-6">
        <h4 className="text-sm font-semibold uppercase tracking-wide text-slate-400">
          age-julkinen avain
        </h4>
        <AgeKeyDisplay value={user.agePublicKey ?? null} />
      </div>
    </section>
  );
}

function Row({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <dt className="text-xs uppercase tracking-wide text-slate-400">{label}</dt>
      <dd className="mt-1 text-sm text-slate-100">{value}</dd>
    </div>
  );
}

function formatDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("fi-FI", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}
